module.exports = __webpack_public_path__ + "img/ic_email.6a1d898e.svg";